// extracted by mini-css-extract-plugin
module.exports = {"pageImage":"HeaderImage_pageImage__2tTjf"};